export * from './ClipboardAltIcon';
